import * as React from 'react';

export type TNewbuildingPurchaseGiftPromoSource = 'sidebar' | 'gallery';

export interface INewbuildingPurchaseGiftPromoContext {
  /** Точки входа акции можно показывать: тогл, конфиг, регион и группа эксперимента */
  isAvailable: boolean;
  openModal(source: TNewbuildingPurchaseGiftPromoSource): void;
  /**
   * Слайд галереи рендерится дважды (обычная и полноэкранная галерея):
   * показ отправляется один раз на страницу.
   */
  trackGallerySlideShow(): void;
}

export const NewbuildingPurchaseGiftPromoContext = React.createContext<INewbuildingPurchaseGiftPromoContext>({
  isAvailable: false,
  openModal: () => {},
  trackGallerySlideShow: () => {},
});

export function useNewbuildingPurchaseGiftPromo(): INewbuildingPurchaseGiftPromoContext {
  return React.useContext(NewbuildingPurchaseGiftPromoContext);
}
